import {Routes} from '@angular/router'
import {LoginComponent} from '@sparbanken-syd/sparbanken-syd-bankid'
import {HOME_PATH, LOGIN_PATH} from './0-application/shared'

/* v8 ignore next */
export const routes: Routes = [
  {
    path: HOME_PATH,
    loadChildren: () => import('./home/routes')
  },
  {
    path: LOGIN_PATH,
    component: LoginComponent
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: LOGIN_PATH
  },
  {
    path: '**',
    redirectTo: LOGIN_PATH
  }
]
